import { registerPlugin } from '@capacitor/core';
import { isNative, platform } from './platform';

interface NativeUpdaterPlugin {
  downloadAndInstall(options: { url: string }): Promise<{ downloadId: number }>;
  getVersionCode(): Promise<{ versionCode: number; versionName: string }>;
}

const bridge = registerPlugin<NativeUpdaterPlugin>('NativeUpdater');

export function supportsInAppUpdate(): boolean {
  return isNative() && platform() === 'android';
}

export async function getInstalledVersionCode(): Promise<number | null> {
  if (!supportsInAppUpdate()) return null;
  try {
    const info = await bridge.getVersionCode();
    return Number(info.versionCode) || null;
  } catch {
    return null;
  }
}

export async function downloadAndInstallUpdate(url: string): Promise<void> {
  if (!supportsInAppUpdate()) throw new Error('in_app_update_unavailable');
  await bridge.downloadAndInstall({ url });
}
